import React, { Component } from 'react';
import PropTypes from 'prop-types';

import MobileHeader from './MobileHeader/index';
import PracticeHeader from '../PracticeHeader/index';
import MobileServiceButtons from './MobileServiceButtons/index';
import PracticeDescription from '../PracticeInfo/PracticeDescription/index';
import OpeningHours from '../PracticeInfo/OpeningHours/index';
import Section from '../PracticeInfo/Section/index';
import OurTeam from './OurTeam/index';
import { practiceProfilePropType } from '../../propTypes/index';
import { actions as appointmentActions } from '../../BookingPageMobile/actions/actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

class MobileView extends Component {
  static propTypes = {
    practice: practiceProfilePropType.isRequired,
    page: PropTypes.object,
    isFetching: PropTypes.bool.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    logout: PropTypes.func.isRequired,
    bookNow: PropTypes.func.isRequired,
    goHome: PropTypes.func.isRequired,
    selectService: PropTypes.func.isRequired,
  };
  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const serviceParam = parseInt(urlParams.get('service'), 10);
    if (serviceParam) {
      const selectedService = this.props.practice.Services.find(
        service => service.Id === serviceParam,
      );
      if (selectedService) {
        this.props.selectService(selectedService);
      }
    }
  }

  shouldComponentUpdate = nextProps =>
    nextProps.practice !== this.props.practice ||
    nextProps.isFetching !== this.props.isFetching ||
    nextProps.isLoggedIn !== this.props.isLoggedIn;
  book = () => {
    this.props.bookNow(this.props.practice.UrlName);
  };
  render() {
    const {
      practice,
      page,
      logout,
      isLoggedIn,
      isFetching,
      goHome,
    } = this.props;
    return !practice.Name ? null : (
      <div>
        <MobileHeader
          practice={practice.Name}
          page={page}
          isLoggedIn={isLoggedIn}
          logout={logout}
          id={practice.UrlName}
        />
        <PracticeHeader practice={practice} isFetching={isFetching} />
        <MobileServiceButtons
          appt={practice.AllowsBookingBy}
          script={practice.AllowsScriptsBy}
          onBook={this.book}
          onScript={goHome}
          allowScripts={practice.AllowsOnlineScripts}
          address={practice.Address}
        />
        <PracticeDescription description={practice.Description} />
        <OpeningHours hours={practice.OpeningHours} note={practice.HourNote} />
        <Section content={practice.Specialties} title="Our Specialties" />
        <Section content={practice.Language} title="Languages we speak" />
        <OurTeam
          team={practice.Doctors}
          orgId={practice.UrlName}
          onBookNow={this.book}
        />
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => ({
  selectService: bindActionCreators(appointmentActions.selectService, dispatch),
});

export default connect(null, mapDispatchToProps)(MobileView);
